import { Layout } from "antd";
import RoutesIndex from "src/routes";
const { Content } = Layout;

export const ContentAdmin = ({formRef}: any) => {
  return (
    <Content
      style={{ scrollSnapAlign: "center",margin: '10px 16px'}}
    >
      <RoutesIndex formRef={formRef} />
    </Content>
  );
};

export default ContentAdmin;
